import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArchive: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArchive"><Path fillRule="evenodd" clipRule="evenodd" d="M10.9142 2H5V8H3V21H21V8H19V4H12.9142L10.9142 2ZM17 8V6H12.0858L10.0858 4H7V8H17ZM7 12H13V14H7V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArchive;
